import React, { useCallback } from 'react';
import './style.css';

const masks = {
  cnpj: (value) => {
    return value
      .replace(/\D/g, '')
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  },
  cpf: (value) => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  },
  phone: (value) => {
    let v = value.replace(/\D/g, '');
    v = v.replace(/^(\d{2})(\d)/g, '($1) $2');
    v = v.replace(/(\d)(\d{4})$/, '$1-$2');
    return v;
  },
  cep: (value) => {
    return value
      .replace(/\D/g, '')
      .replace(/^(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{3})\d+?$/, '$1');
  },
  date: (value) => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '$1/$2')
      .replace(/(\d{2})(\d)/, '$1/$2')
      .replace(/(\d{4})\d+?$/, '$1');
  },
  agency: (value) => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(-\d{1})\d+?$/, '$1');
  },
  account: (value) => {
    const digits = value.replace(/\D/g, '');
    if (digits.length <= 1) {
      return digits;
    }
    return digits.replace(/(\d+)(\d)$/, '$1-$2');
  },
  currency: (value) => {
    value = value.replace(/\D/g, '');
    value = (Number(value) / 100).toFixed(2) + '';
    value = value.replace('.', ',');
    value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    return `R$ ${value}`;
  },
  percent: (value) => {
    value = value.replace(/\D/g, '');
    value = (Number(value) / 100).toFixed(2) + '';
    value = value.replace('.', ',');
    return `${value}%`;
  },
  plate: (value) => {
    let v = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (v.length > 3) {
      v = v.replace(/^([A-Z]{3})([A-Z0-9]+)/, '$1-$2');
    }
    return v;
  },
  year: (value) => {
    return value.replace(/\D/g, '');
  },
  renavam: (value) => {
    return value.replace(/\D/g, '');
  },
};

const maskLengths = {
  cnpj: 18,
  cpf: 14,
  phone: 15,
  cep: 9,
  date: 10,
  agency: 6,
  account: 20,
  percent: 7,
  plate: 8,
  year: 4,
  renavam: 11,
};

function Input({ id, label, className = '', icon: Icon, mask, onChange, maxLength, multiline, rows, error, hint, ...rest }) {
  const handleChange = useCallback(
    (e) => {
      if (mask) {
        const maskType = typeof mask === 'string' ? mask : null;
        const maskFn = maskType && masks[maskType] ? masks[maskType] : (typeof mask === 'function' ? mask : null);
        
        if (maskFn) {
          e.target.value = maskFn(e.target.value);
        }
      }

      if (onChange) {
        onChange(e);
      }
    },
    [mask, onChange]
  );

  const finalMaxLength = maxLength || (typeof mask === 'string' ? maskLengths[mask] : undefined);

  return (
    <div className={`field ${className}`}>
      {label && (
        <label className="field-label" htmlFor={id}>
          {label}
        </label>
      )}
      <div className={`input-wrapper ${multiline ? 'multiline' : ''}`}>
        {Icon && (
          <div className="input-icon">
            <Icon size={18} />
          </div>
        )}
        {multiline ? (
          <textarea
            id={id}
            className={`field-input ${Icon ? 'has-icon' : ''} ${error ? 'has-error' : ''} field-textarea`}
            onChange={handleChange}
            maxLength={finalMaxLength}
            rows={rows || 4}
            {...rest}
          />
        ) : (
          <input 
            id={id} 
            className={`field-input ${Icon ? 'has-icon' : ''} ${error ? 'has-error' : ''}`} 
            onChange={handleChange}
            maxLength={finalMaxLength}
            {...rest} 
          />
        )}
      </div>
      {hint && (
        <span className="field-hint" style={{ fontSize: '12px', color: 'var(--text-secondary, #666)', marginTop: '4px', display: 'block' }}>
          {hint}
        </span>
      )}
    </div>
  );
}

export default Input;
